import { MAX_VIDEO_MEDIAFILE_SIZE, VIDEO_MEDIA_ACCEPT } from '@shared/config/media';

const extensions = Object.values(VIDEO_MEDIA_ACCEPT)
  .flat()
  .map((extension) => extension.toLowerCase());

export const filterAcceptedVideoFiles = (files: File[]) =>
  files.filter(
    (file) =>
      file.size > 0 &&
      file.size <= MAX_VIDEO_MEDIAFILE_SIZE &&
      extensions.some((extension) => file.name.toLowerCase().endsWith(extension))
  );
